import { AtlasIconOptions, AtlasIcon, AtlasPoint, AtlasSize } from '../../mu-atlas/interfaces/mu-atlas-types.interface';

export class MuMapLeafletIcon implements AtlasIcon {
  public readonly url: string;
  public readonly className: string;
  public readonly size: AtlasSize;
  public readonly anchor: AtlasPoint;
  public readonly labelOrigin: AtlasPoint;

  constructor(icon: AtlasIconOptions) {
    this.url = icon.url;
    this.size = icon.size ?? { width: 42, height: 52 };
    this.anchor = icon.anchor ?? { x: this.size.width / 2, y: this.size.height };
    this.labelOrigin = icon.labelOrigin ?? { x: 0, y: 0 };
    this.className = icon.className || ''
  }
}
